import { Grid, Typography } from "@mui/material";
import { PropsWithChildren } from "react";

import { RowControlPoints } from "./RowControlPoints";
import { RowImage } from "./RowImage";
import { RowNoInput } from "./RowNoInput";
import { RowOptions } from "./RowOptions";
import { RowText } from "./RowText";
import { WorkListQuestionType } from "../../../../models/worklist/WorkListQuestionType";
import {
    WorkOrderAnswer,
    WorkOrderControlPoint,
} from "../../../../models/workorder/WorkOrder";

export interface RowChoiceMeta {
    imageColumns: number;
}

export interface RowChoiceProps {
    answer: WorkOrderAnswer;
    controlPoints: WorkOrderControlPoint[];
    meta: RowChoiceMeta;
}

export function RowChoice(props: RowChoiceProps) {
    switch (props.answer.type) {
        case WorkListQuestionType.Text:
        case WorkListQuestionType.TextMultiline:
            return <RowText {...props} />;
        case WorkListQuestionType.CheckBox:
        case WorkListQuestionType.RadioButtons:
        case WorkListQuestionType.RadioYesNo:
        case WorkListQuestionType.Dropdown:
            return <RowOptions {...props} />;
        case WorkListQuestionType.ImageUpload:
            return <RowImage {...props} />;
        case WorkListQuestionType.ControlPoints:
            return <RowControlPoints {...props} />;
        default:
            return <RowNoInput {...props} />;
    }
}

interface RowBaseProps {
    question?: string;
}

export function RowBase({
    question,
    children,
}: PropsWithChildren<RowBaseProps>) {
    return (
        <Grid container gap={3}>
            {question && (
                <Grid item xs>
                    <pre
                        style={{
                            whiteSpace: "pre-line",
                            wordWrap: "break-word",
                            margin: 0,
                        }}
                    >
                        <Typography>{question}</Typography>
                    </pre>
                </Grid>
            )}
            <Grid item xs>
                {children}
            </Grid>
        </Grid>
    );
}
